import { render, staticRenderFns } from "./JiaoHuPingView.vue?vue&type=template&id=05bcdddc&scoped=true"
import script from "./JiaoHuPingView.vue?vue&type=script&lang=js"
export * from "./JiaoHuPingView.vue?vue&type=script&lang=js"
import style0 from "./JiaoHuPingView.vue?vue&type=style&index=0&id=05bcdddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bcdddc",
  null
  
)

export default component.exports